module.exports = __webpack_public_path__ + "static/media/211CS232.2d4ff3e8.heic";